(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServantExceptionDurationController', ServantExceptionDurationController);

    ServantExceptionDurationController.$inject = ['$rootScope', '$scope', '$state', 'ParseLinks', 'entity', 'TimingInfo', 'translatePartialLoader', 'ServantCustom', '$timeout'];

    function ServantExceptionDurationController($rootScope, $scope, $state, ParseLinks, entity, TimingInfo, translatePartialLoader, ServantCustom, $timeout) {

        var vm = this;
        vm.isSaving = false;
        vm.defaultServantId = null;
        vm.availabilityMode = "CLOSE";
        vm.canSelectServant = false;

        vm.selectedServant = null;
        vm.exdurations = [];

        vm.okModal = okModal;
        vm.closeModal = closeModal;

        vm.newDate = null;
        vm.addDuration = addDuration;
        vm.removeDuration = removeDuration;
        vm.startDate = new Date();
        vm.endDate = null;
        vm.startTime;
        vm.endTime;
        vm.servantList = [];
        vm.loadServants = loadServants;
        vm.errorMessage = null;
        vm.isDateEqual = isDateEqual;
        vm.showEndDate = false;
        vm.getDurationBlockClass = getDurationBlockClass;
        vm.isFullDay = isFullDay;
        vm.getTitleByAvailability = getTitleByAvailability;

        $rootScope.$broadcast('hideNavBar');

        loadAll();

        function loadAll() {

            if (entity) {
                if (entity.defaultServantId)
                    vm.defaultServantId = entity.defaultServantId;
                if (entity.availabilityMode)
                    vm.availabilityMode = entity.availabilityMode;
                if (entity.canSelectServant)
                    vm.canSelectServant = entity.canSelectServant;
            }

            loadServants();

        }

        function loadServants() {
            //if servant_login just current servant must selected
            ServantCustom.findServantsByCompany().query(function (result) {
                vm.servantList = result;
                setDefaultServant();

            });
        }


        function setDefaultServant() {
            if (vm.servantList) {
                if (vm.defaultServantId) {
                    angular.forEach(vm.servantList, function (srv) {
                        if (srv.id == vm.defaultServantId) {
                            vm.selectedServant = srv;
                            return;
                        }
                    });
                }
            }

        }


        Date.prototype.toLocalISOString = function () {
            var mm = this.getMonth() + 1; // getMonth() is zero-based
            var dd = this.getDate();
            if (mm < 10) mm = '0' + mm;
            if (dd < 10) dd = '0' + dd;

            return [this.getFullYear(), mm, dd].join('-'); // padding
        };

        function setOffDate() {
            //
            if (vm.selectedDatePeriod != undefined) {
                vm.selectedDatePeriod.offdays = [];
                angular.forEach(vm.offDates, function (val) {
                    var dateTemp = new Date(val.value);
                    if (dateTemp)
                        vm.selectedDatePeriod.offdays.push({offDate: dateTemp.toLocalISOString()});
                });
            }
        }

        function addDuration() {

            vm.errorMessage = null;
            if (!vm.exdurations)
                vm.exdurations = [];
            var dur = makeDurationObject();
            if (dur && vm.startDate != null && vm.endDate != null) {

                var persianDate = new JDate(vm.newDate);
                var hasAddedBefore = false;
                angular.forEach(vm.exdurations, function (val) {
                    if (val.startDate && val.endDate && val.startDate.toLocaleString() == vm.startDate.toLocaleString() &&
                        ((!val.startTime && !vm.startTime) || (val.startTime && vm.startTime && val.startTime.toLocaleString() == vm.startTime.toLocaleString())) &&
                        val.endDate.toLocaleString() == vm.endDate.toLocaleString() &&
                        ((!val.endTime && !vm.endTime) || (val.endTime && vm.endTime && val.endTime.toLocaleString() == vm.endTime.toLocaleString()))
                    )

                        hasAddedBefore = true;
                });
                if (!hasAddedBefore) {

                    vm.exdurations.push(dur);
                    scrollToDurations();
                } else {
                    alert('بازه زمانی مشخص شده تکراری است');
                }
            }
        }

        function alert(msg) {
            vm.errorMessage = msg;
        }

        function makeDurationObject(ev) {
            if (!vm.showEndDate)
                vm.endDate = vm.startDate;

            if (vm.showEndDate && !vm.endDate) {
                alert('تاریخ پایان را وارد کنید');
                return null;
            }

            if (vm.showEndDate && vm.startDate > vm.endDate) {
                alert('تاریخ پایان باید بزرگتر از تاریخ شروع باشد');
                return null;
            }

            if (!vm.startTime || !vm.endTime) {
                alert('ساعت شروع و پایان را وارد کنید');
                return null;
            } else {

                return {
                    availabilityMode: vm.availabilityMode,
                    startDate: vm.startDate,
                    endDate: vm.endDate,
                    startTime: vm.startTime,
                    endTime: vm.endTime
                };
            }

        }

        function removeDuration(date) {
            if (vm.exdurations != undefined)
                vm.exdurations = vm.exdurations.filter(function (item) {
                    return item != date;
                });
        }

        function isDateEqual(startDate, endDate) {


            var start = new Date(startDate).toLocalISOString();
            var end = new Date(endDate).toLocalISOString();

            if (start == end)
                return true;

            return false;


        }

        function getDurationBlockClass(dur) {
            if (dur && dur.availabilityMode) {
                if (dur.availabilityMode == 'CLOSE')
                    return 'CloseDurationBlock';
                else
                    return 'OpenDurationBlock';
            }
        }


        function isFullDay(item) {
            var date1 = new Date(item.startTime);
            var date2 = new Date(item.endTime);
            var diffTime = Math.abs(date2 - date1);

            if (diffTime / 1000 == 86340) {
                return true;
            }
            return false;
        }

        function okModal() {

            console.error("Is Saving Maj : " + vm.isSaving);

            if (vm.isSaving)
                return;


            vm.isSaving = true;

            if (!vm.exdurations || vm.exdurations.length == 0) {
                alert("هیچ زمانی انتخاب نشده است");
                vm.isSaving = false;

                return;
            }

            if (!vm.selectedServant) {
                alert("پرسنل انتخاب نشده است");
                vm.isSaving = false;
                return;
            }

            setServant();
            var exceptionHelper = {};
            exceptionHelper.servantExceptionDurations = vm.exdurations;


            TimingInfo.insertServantExceptionDuration().save(exceptionHelper, saveSuccess, saveError);

        }

        function setServant() {

            angular.forEach(vm.exdurations, function (dur) {
                dur.servantId = vm.selectedServant.id;
            })
        }

        function saveSuccess(result) {

            // if user click more than once it causes a problem
            $timeout(function () {
                vm.isSaving = false;
                $rootScope.$broadcast('showNavBar');
                $rootScope.$broadcast('reloadServantExceptionDurationListEvent');

                if ($rootScope.fromState && $rootScope.fromState.name == 'supplierPanel-v2.companyServants.edit'
                    && $rootScope.fromStateParams
                ) {
                    $state.go('supplierPanel-v2.companyServants.edit', {id: $rootScope.fromStateParams.id});
                } else {
                    $state.go('supplierPanel-v2.calendar-v2');
                }


            }, 500);


            // $state.go('supplierPanel-v2.calendar');

        }

        function saveError() {
            vm.isSaving = false;
            closeModal();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            if ($rootScope.fromState && $rootScope.fromState.name == 'supplierPanel-v2.companyServants.edit'
                && $rootScope.fromStateParams
            ) {
                $state.go('supplierPanel-v2.companyServants.edit', {id: $rootScope.fromStateParams.id});
            } else {
                $state.go('supplierPanel-v2.calendar-v2');
            }
        }

        function alert(msg) {
            vm.errorMessage = msg;
        }

        function scrollToDurations() {
            $timeout(function () {
                var el = document.getElementById("exceptionDuration");
                el.scrollIntoView();
            }, 100);

        }

        function getTitleByAvailability() {
            if (vm.availabilityMode == 'CLOSE')
                return 'tikonApp.scheduleInfo.servantExceptionDuration.closeTitle';
            if (vm.availabilityMode == 'OPEN')
                return 'tikonApp.scheduleInfo.servantExceptionDuration.openTitle';
        }


    }
})();
